import React, { useState, useEffect } from "react";
import Vimeo from "@u-wave/react-vimeo";
import { SlideDown } from "react-slidedown";
import "react-slidedown/lib/slidedown.css";
import axios from "axios";
import StyledSingleVideo from "./SingleVideo-styles";
import styled from "styled-components";
import { useFilterContext } from "../context/FilterProvider";

export const SingleVideo = (props) => {
	const { video, showThumbs } = props;
	const [open, setOpen] = useState(false);
	const [thumbnail, setThumbnail] = useState("");
	const [watched, setWatched] = useState(false);
	const userId = document.getElementById("video_user")?.getAttribute("data-user");
	const [state, dispatch] = useFilterContext();

	useEffect(() => {
		const getAndSetThumbnail = async () => {
			const thumb = await axios.get("https://vimeo.com/api/v2/video/" + video.vimeo_id + ".json");
			setThumbnail(thumb.data[0].thumbnail_medium);
		};

		if (video) {
			getAndSetThumbnail();
		}
	}, [thumbnail, video]);

	const toggle = () => {
		if (state.toggle !== video.vimeo_id) {
			dispatch({ type: "UPDATE_TOGGLE", payload: video.vimeo_id });
		} else {
			dispatch({ type: "UPDATE_TOGGLE", payload: "" });
		}
	};

	const trackTime = (currentTime) => {
		const { percent } = currentTime;
		if (userId && percent > 0.9 && !watched) {
			console.log("tracktime!", userId);
			setWatched(true);
			trackVideo(video.vimeo_id, userId);
		}
	};

	const trackVideo = async (vid, uid) => {
		let response;
		try {
			response = await axios({
				method: "post",
				url: "https://sourcesofstrength.org/wp-json/sos-videos/v1/addwatched",
				data: {
					userId: uid,
					videoId: vid,
				},
			});
			return response.data;
		} catch (error) {
			console.error(error);
			response = error;
		}
		return response;
	};

	return (
		<>
			<StyledSingleVideo
				className={showThumbs ? "show-thumbnails styledsinglevideo" : "styledsinglevideo"}
			>
				<button
					className="thumb"
					onClick={toggle}
					style={{
						backgroundImage: showThumbs ? `url('${thumbnail}')` : "",
					}}
				>
					<span className="inner">
						<h3 className="video-title">{video.name.replace("#038;", "")}</h3>
						<span className="play-button"></span>
					</span>
				</button>
			</StyledSingleVideo>
			<SlideDown className={"my-dropdown-slidedown"} closed={state.toggle !== video.vimeo_id}>
				<StyledSlideDownInner>
					<a className="beforeArrow"></a>
					<Vimeo video={video.vimeo_id} onTimeUpdate={trackTime} responsive />
					<a className="nextArrow"></a>
				</StyledSlideDownInner>
			</SlideDown>
		</>
	);
};

const StyledSlideDownInner = styled.section`
	background: #303030;
	display: flex;
	align-content: center;
	align-items: center;
	justify-content: center;
	padding: 60px 0;
	position: relative;

	> div {
		width: 80%;
	}
`;
